const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  SMALL_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/small/',
  MEDIUM_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/medium/',
  LARGE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/large/',
  DEFAULT_LANGUAGE: 'en-us',
  CACHE_NAME: 'restaurant-api',
  DATABASE_NAME: 'restaurant-catalogue-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurants',
};

export default CONFIG;
